import { createSelector } from 'reselect'
import { sumBy } from 'lodash'

const selectSubOrder = state => state.screens.SubcontractorSubOrder.subOrder

export default createSelector(
  selectSubOrder,
  (subOrder) => {

    // Calculate total from items (rate * quantity)
    const itemsTotal = subOrder.sub_order_groups.reduce((carry, subOrderGroup) => {
      return carry + (sumBy(subOrderGroup.sub_order_items, item => {
        // Use rate if available, otherwise use total
        return item.rate ? (item.rate * (item.quantity || 0)) : (item.total || 0)
      }) || 0)
    }, 0)

    // Apply set percentage if available
    const setPercentage = subOrder.set_percentage || 0
    const displayTotal = setPercentage > 0 ? (itemsTotal * setPercentage / 100) : itemsTotal

    return { 
      total: displayTotal,
      setPercentage: subOrder.set_percentage,
    }

  },
)
